import SEO from "@/components/SEO";
import { PageHero } from "@/components/common/Bits";
import { COMPANY } from "@/data/company";

const CONTENT = {
    privacy: {
        title: "Privacy Policy",
        path: "/privacy-policy",
        sections: [
            { h: "Overview", p: "This Privacy Policy explains how ProCare.SG handles personal information collected through this website. This is a placeholder policy to be reviewed and finalised before launch." },
            { h: "Information We Collect", p: "When you submit an enquiry, we may collect your name, contact details, property information and any details you choose to provide. This website does not permanently store form submissions in its current frontend-only form." },
            { h: "How We Use Information", p: "Information is used solely to respond to your enquiry and coordinate the services you request. We do not sell your personal data." },
            { h: "Data Retention", p: "Once a backend is connected, enquiry data will be retained only as long as necessary to provide our services and meet legal obligations." },
            { h: "Your Rights", p: "You may request access to, correction of, or deletion of your personal data by contacting us at the details below." },
            { h: "Contact", p: `For privacy matters, contact ${COMPANY.name} at ${COMPANY.email} or ${COMPANY.mobile}.` },
        ],
    },
    terms: {
        title: "Terms of Use",
        path: "/terms-of-use",
        sections: [
            { h: "Acceptance of Terms", p: "By using this website, you agree to these Terms of Use. This is a placeholder document to be reviewed before launch." },
            { h: "Use of the Website", p: "This website provides information about ProCare.SG's property services. Content is provided for general information and may change without notice." },
            { h: "Service Enquiries", p: "Submitting an enquiry does not constitute a binding contract. All works are subject to a separate agreed quotation and scope of work." },
            { h: "Intellectual Property", p: "The ProCare.SG name, logo and website content are the property of ProCare.SG and may not be reproduced without permission." },
            { h: "Limitation of Liability", p: "We make no warranties about the completeness or accuracy of website content. Service terms are governed by individual quotations." },
            { h: "Contact", p: `Questions about these terms can be directed to ${COMPANY.email}.` },
        ],
    },
};

export default function LegalPage({ kind = "privacy" }) {
    const data = CONTENT[kind];
    return (
        <>
            <SEO title={data.title} path={data.path} />
            <PageHero label="Legal" title={data.title} subtitle="Please review this placeholder document. Final legal content should be confirmed before launch." />
            <section className="py-20">
                <div className="mx-auto max-w-3xl space-y-8 px-6">
                    {data.sections.map((s) => (
                        <div key={s.h}>
                            <h2 className="font-display text-2xl font-semibold text-brand-blue">{s.h}</h2>
                            <p className="mt-3 leading-relaxed text-brand-ink/70">{s.p}</p>
                        </div>
                    ))}
                    <p className="pt-4 text-sm text-brand-ink/60">Last updated: {new Date().toLocaleDateString("en-SG", { day: "numeric", month: "long", year: "numeric" })}</p>
                </div>
            </section>
        </>
    );
}
